<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="UID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
                    <el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="卡密" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.cardSecret" placeholder="请输入卡密"></el-input>
					</el-form-item>
					<el-form-item label="类别:" label-width="80px">
						<el-select v-model="searchInfo.type" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="AI引擎卡密" :value="0">AI引擎卡密</el-option>
							<el-option key="1" label="点数卡密" :value="1">点数卡密</el-option>
							
							
						</el-select>
					</el-form-item>

					<el-form-item label="支付状态:" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="已付款" :value="1">已付款</el-option>
						
						</el-select>
					</el-form-item>

					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
							 start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" border>
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
            <!-- <el-table-column prop="id" align="center" width="90" label="#">
			</el-table-column> -->
			<el-table-column prop="" label="用户" align="center" width="250" :show-overflow-tooltip="true">
                 <template slot-scope="scope">
                    <span >{{ scope.row.userId }}</span>
					<span v-if="scope.row.username"> ~ {{ scope.row.username }}~{{scope.row.phone}}</span>
				</template>
			</el-table-column>
            <el-table-column prop="teamLevel" label="会员级别" align="center" width="90" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.teamLevel==0">会员</span>
					<span v-if="scope.row.teamLevel==1">V1</span>
					<span v-if="scope.row.teamLevel==2">V2</span>
					<span v-if="scope.row.teamLevel==3">V3</span>
                    <span v-if="scope.row.teamLevel==4">V4</span>
					<span v-if="scope.row.teamLevel==5">V5</span>
				</template>
            </el-table-column>
			<el-table-column prop="type" label="类别" align="center" width="90" :show-overflow-tooltip="true">
			    <template slot-scope="scope">
			        <span v-if="scope.row.type==0">AI引擎卡密</span>
					<span v-if="scope.row.type==1">点数卡密</span>
					
				</template>
			</el-table-column>
			
			<el-table-column prop="price" label="金额" align="center" width="130" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="teamLevel" label="支付方式" align="center" width="120" :show-overflow-tooltip="true">
			    <template slot-scope="scope">
			        <span v-if="scope.row.payType=='wx'">微信支付</span>
					<span v-if="scope.row.payType=='alipay'">支付宝支付</span>
					<span v-if="scope.row.payType=='integral'">积分抵扣</span>
					<span v-if="scope.row.payType=='wxplural'">微信积分混合支付</span>
			        <span v-if="scope.row.payType=='aliplural'">支付宝混合支付</span>
				</template>
			</el-table-column>
       
			<!-- <el-table-column prop="statusDesc" label="订单状态" align="center" width="120" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="status" label="订单状态" align="center" width="90" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.status==0" style="color:#E6A23C;">待付款</span>
					<span v-if="scope.row.status==1" style="color:#409EFF;">已付款</span>
					
				</template>
            </el-table-column>
		
			
			<el-table-column prop="createTime" label="创建时间" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="payTime" label="付款时间" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="cardSecret" label="卡密"  align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span @click="onCopy(scope.row.cardSecret)">{{scope.row.cardSecret}}</span>
					<!-- <el-button size="small" type="text" @click="showContent(scope.row.cardSecret)">查看</el-button> -->
				</template>
			</el-table-column>

		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px;" background :current-page="sliderlist.pageNum" @current-change="pageChange"
		 layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 订单详情对话框 -->
		<el-dialog title="卡密" :visible.sync="dialogVisible" width="60%" :before-close="handleClose" :close-on-click-modal="false">
			<div>
				<div style="display: flex;align-items: center;">
					<span>卡密：</span>
					<span v-if="orderInfo">
						<span>{{orderInfo}}</span>
						<span style="padding-left: 10px;text-decoration: underline;color: red;" @click="onCopy">一键复制</span>
					</span>
					<span v-else>暂无</span>
				</div>
				
				
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderList: [],
				dialogVisible: false,
				loading:false,
				editDialogVisible: false,
				searchInfo: {
					brandId: '',
                	status: ''
				},
				orderInfo: '',
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				sysExpressList: [],
				storeOrder: {},
				shipments_orderCode:'',
				shipments_name:'',
				shipments_address:'',
				expressType:'',
				ExpDialog: false , //查看物流弹窗
				wudetail:[{}], //查看物流数据

				storeFlage: false,
			};
		},
		methods: {
		
			onCopy(e) {
					var input = document.createElement("input"); // 创建input对象
			        input.value = e; // 设置复制内容
			        document.body.appendChild(input); // 添加临时实例
			        input.select(); // 选择实例内容
			        document.execCommand("Copy"); // 执行复制
			        document.body.removeChild(input); // 删除临时实例
			        this.$message.success('复制成功！');
			},
			
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()

			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					...this.searchInfo,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.findListafdOrder(data).then((res => {
					// console.log('联盟订单---',res.data.list)
					if (res.state == 'success') {
						this.orderList = res.data.list
						this.sliderlist = res.data
						// console.log(this.sliderlist)

					}
				}))
			},
			
			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				
				this.orderInfo = e
				// console.log(this.orderInfo)
				this.dialogVisible = true
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			
		},

		created() {
			this.storeOrderList();
		},
		mounted() {
			
		}
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
        
	}
</style>
